export const getHighEdenData = () => ({
  name: "High Eden",
  country: "Australie",
  region: "Barossa Valley",
  description: "High Eden est une sous-région d'altitude de la Barossa Valley, réputée pour ses vins blancs frais et ses rouges élégants. Son climat frais et ses vignobles en altitude créent des conditions idéales pour des vins de grande finesse.",
  type: "subregion",
  mapAreas: [
    { region: "High Eden", x: 50, y: 65, color: "#8a4a8a", size: 2 }
  ],
  statistics: {
    totalArea: "500 ha",
    production: "0.04 million hectolitres",
    altitude: "500-700m",
    appellations: "High Eden GI",
    exportPercentage: "25%"
  },
  characteristics: {
    climate: "Climat frais avec altitude très élevée, étés chauds, hivers froids, grandes amplitudes thermiques",
    soil: "Sols granitiques, argileux, excellente drainage",
    viticulture: "Viticulture traditionnelle, vignobles en altitude, rendements très limités"
  },
  wineStyles: {
    red: "Shiraz élégants et frais, avec des tanins soyeux et une complexité aromatique",
    white: "Riesling frais et tendus, Chardonnay aromatiques, Sauvignon Blanc vifs",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture dans High Eden s'est développée plus récemment, dans les années 1980. La sous-région s'est rapidement imposée pour ses vins de climat frais de qualité exceptionnelle.",
  foodPairing: "Cuisine australienne : fruits de mer, poissons, viandes blanches, fromages affinés, cuisine fusion.",
  grapeVarieties: {
    white: ["Riesling", "Chardonnay", "Sauvignon Blanc"],
    red: ["Shiraz", "Cabernet Sauvignon", "Merlot"]
  },
  keyProducers: ["Pewsey Vale", "Henschke", "Yalumba"],
  notableWines: {
    "riesling": "Riesling frais et tendus",
    "shiraz": "Shiraz élégants et frais",
    "chardonnay": "Chardonnay aromatiques et complexes"
  }
}); 